import { Observable } from 'rxjs';
import { CitiesResponse } from '../models/cities.model';

export abstract class CitiesRepository {
    abstract getCities(): Observable<CitiesResponse>;
}
